// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/KioskApp/kiosk.scss
// module id = 101
// module chunks = 0